export type SummaryToFn = (id?: string) => { pathname: string; section: string; id?: string };

export const createSummaryTo =
	(pathname: string, section: string): SummaryToFn =>
	(id) => ({ pathname, section, id });

export const buildSummaryLink = (
	to: { pathname: string; section: string; id?: string },
	searchParams: URLSearchParams,
): string => {
	const params = new URLSearchParams(searchParams);
	params.set("section", to.section);
	if (to.id !== undefined) params.set("st", to.id);
	else params.delete("st");
	return `${to.pathname}?${params}`;
};
